<template>
  <b-dropdown 
    size="md" 
    right 
    variant="link" 
    :toggle-class="`text-decoration-none border-form px-2 rounded-100px ${$is_mobile_view ? 'bg-white mb-1' : ''}`"
    menu-class="py-0 light-box-shadow" 
    no-caret>
    <template #button-content>
      <div class="d-flex align-items-center">
        <div style="height: 26px;width:26px;" class="rounded-circle overflow-hidden lh-1">
          <img :src="getCurrentUser.avatar" :alt="getCurrentUser.first_name" class="img-fit">
        </div>
        <template v-if="!$is_mobile_view">
          <p class="mb-0 body-2-4 mx-2 text-truncate text-left" style="max-width: 130px;">{{getCurrentUser.first_name}}</p>
          <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.33147 3.87295C2.47757 3.72392 2.70619 3.71037 2.8673 3.83231L2.91345 3.87295L6.21094 7.23671L9.50842 3.87295C9.65452 3.72392 9.88315 3.71037 10.0443 3.83231L10.0904 3.87295C10.2365 4.02198 10.2498 4.25519 10.1303 4.41952L10.0904 4.4666L6.50193 8.12705C6.35583 8.27608 6.12721 8.28963 5.9661 8.1677L5.91995 8.12705L2.33147 4.4666C2.17076 4.30267 2.17076 4.03688 2.33147 3.87295Z" fill="black"></path>
          </svg>
        </template>
      </div>
    </template>

    <b-dropdown-text text-class="p-0" style="width: 300px;">
      <userMenuDetail />
    </b-dropdown-text>
  </b-dropdown>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { get } from '../../../../services';
  import userMenuDetail from '../../userMenuDetail.vue';

  export default {
    components:{
      userMenuDetail
    },
    computed:{
      ...mapGetters(['getCurrentUser', 'getMerchant'])
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/desktop/userDropdownMenu.vue